export var Result;
(function (Result) {
    Result["Win"] = "win";
    Result["Loss"] = "loss";
    Result["Draw"] = "draw";
})(Result || (Result = {}));
